import type { UiNode, UiNodeInputAttributes } from '@ory/client';

import { FormItem } from '@/components/FormItem';
import Input from '@/components/Input/Input';
import { useNodeTranslation } from '@/features/auth/hooks/useNodeTranslation';

/** 表示順序: デフォルト入力フィールドは中間に配置 */
export const ORDER = 50;

type Props = {
  node: UiNode;
  disabled?: boolean;
};

/**
 * Default inputノードコンポーネント
 *
 * Ory KratosのServer Driven UIで返されるinputフィールドのデフォルト実装です。
 *
 * @see https://www.ory.com/docs/kratos/concepts/ui-user-interface#default-input-node-rendering
 */
export function DefaultInput({ node, disabled }: Props) {
  const { translateUiText } = useNodeTranslation();
  const attrs = node.attributes as UiNodeInputAttributes;

  const label = node.meta?.label ? translateUiText(node.meta.label) : undefined;
  const errorMessages = node.messages
    ?.filter((msg) => msg.type === 'error')
    .map((msg) => translateUiText(msg));

  return (
    <FormItem
      fieldTitle={label}
      optional={!attrs.required}
      errorMessage={errorMessages?.[0]}
      className="w-full"
      fieldInput={
        <Input
          type={attrs.type}
          name={attrs.name}
          defaultValue={attrs.value as string}
          disabled={disabled ?? attrs.disabled}
          required={attrs.required}
          placeholder={(attrs as { placeholder?: string }).placeholder}
          width="100%"
          error={Boolean(errorMessages?.length)}
          autoComplete={attrs.autocomplete as string | undefined}
        />
      }
    />
  );
}
